import React, { useContext, useState } from "react";
import "./Navbar.css";
import { HiXMark, HiBars4 } from "react-icons/hi2";
import logo from "../../img/logo.png";
import { Link } from "react-router-dom";
import { HiOutlineShoppingCart } from "react-icons/hi";
import { DataContext } from "../../context/contextAPI";
import { useAuth } from "../../context/contextAPI";

const Header = ({ cartItems }) => {
  const { isAuthenticated } = useAuth();
  const links = [
    { id: 1, name: "Nos produits", link: "produits" },
    { id: 2, name: isAuthenticated ? "Mon compte" : "Connexion", link: isAuthenticated ? "/utilisateur/profil" : "auth/connexion" },
    { id: 3, name: "Inscription gratuit", link: "auth/inscription" },
  ];

  const [open, setOpen] = useState(false);
  const { cart } = useContext(DataContext);

  return (
    <nav className="w-full fixed z-50 bg-pink-600">
      <div className="flex items-center justify-between mx-4 md:mx-10 py-3">
        <div
          onClick={() => setOpen(!open)}
          className="cursor-pointer md:hidden text-white"
        >
          {open ? <HiXMark size={26} /> : <HiBars4 size={26} />}
        </div>

        {/* Section logo */}
        <Link to="/" className="flex gap-1 items-center">
          <img src={logo} alt="Logo" className="w-10 md:w-12 lg:w-16" />
          <h3 className="text-2xl md:text-3xl lg:text-5xl poppins-bold text-white">
            ECOKAZ
          </h3>
        </Link>

        <div className="flex">
          <ul
            className={`md:space-y-0 md:flex md:items-center md:pb-0 gap-4 absolute md:static md:z-auto z-[-1] left-0 w-full md:w-auto mt-4 md:mt-0 md:pl-0 px-2 bg-pink-600 md:bg-transparent transition-all duration-500 ease-in ${
              open ? "top-14 py-3" : "top-[-490px]"
            }`}
          >
            {links.map((link) => (
              <li key={link.id} className="py-2 md:py-0">
                <Link
                  activeClass="active"
                  to={link.link}
                  className="text-white text-sm md:text-base link-underline uppercase poppins-bold"
                  onClick={() => setOpen(false)}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
          <Link className="btn btn-ghost btn-circle" to="/panier">
            <div className="indicator">
              <HiOutlineShoppingCart
                size={28}
                color="#ffffff"
                to="/cart"
                className="w-7"
              />
              {cart.length && (
                <span className="badge badge-md bg-black indicator-item text-white">
                  {cart.length}
                </span>
              )}
            </div>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Header;
